// extracted by mini-css-extract-plugin
export default {"auth":"styles-module_auth---YLPXE","auth-footer":"styles-module_auth-footer---G8wc5","login-logo":"styles-module_login-logo---BSMpu","login":"styles-module_login---DP3qQ"};